import Handler from "./Handler";
import DiscussionModel from "../models/DiscussionModel";
import * as Immutable from "immutable";
import CommentModel from "../models/CommentModel";

export default class ErrorHandler extends Handler {

    public handle(model: DiscussionModel, action: string, params?: any): DiscussionModel {
        switch (action) {
            case "error":
                return this.handleError(model, params);
            case "error/confirm":
                return this.handleConfirm(model, params);
            default:
                return model;
        }
    }

    private handleError(model: DiscussionModel, type: number): DiscussionModel {
        model = model.showModalError(type);
        return model;
    }

    private handleConfirm(model: DiscussionModel, params: any): DiscussionModel {
        model = model.hideModalError();
        return model;
    }
}